module.exports = __webpack_public_path__ + "static/img/5516_phase_function_Paper_Points.6b8bc94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5516_phase_function_Paper_Points.png
// module id = sX/Y
// module chunks = 0